import React, { useRef, useState } from "react";
import Papa from "papaparse";
import Popup from "../Popup/Popup";

const UploadStep = ({ handleFileChange, setFile, uploadType }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const fileInputRef = useRef(null);

  const showErrorPopup = (message) => {
    setPopupMessage(message);
    setIsPopupVisible(true);
  };
  const getSampleData = () => {
    switch (uploadType) {
      case "eventCreate":
        return [
          {
            event_name: "SCORE",
            start_date: "25-12-2024",
            end_date: "25-12-2024",
            start_time: "09:00 AM",
            end_time: "11:00 AM",
            event_level: "Prelims",
            event_round: "1",
            school_id: "SCHOOL123",
          },
        ];
      case "eventReschedule":
        return [
          {
            event_name: "SCORE",
            school_id: "SCHOOL123",
            current_start_date_time: "2025-01-24T10:00",
            current_end_date_time: "2025-01-24T10:45",
            reschedule_start_date_time: "2025-02-24T10:00",
            reschedule_end_date_time: "2025-02-24T10:45",
            level: "Prelims",
            round: "1",
          },
        ];
      case "eventDelete":
        return [
          {
            school_id: "SCHOOL123",
            old_start_date: "25-12-2024",
            old_end_date: "25-12-2024",
            start_time: "09:00",
            end_time: "15:00",
          },
        ];
      case "studentRegister":
        return [
          {
            isd_code: "91",
            first_name: "John",
            last_name: "Doe",
            phone: "1234567890",
            grade: "10",
            school_id: "SCHOOL123",
          },
        ];
      case "uploadOfflineResponses":
        return [
          {
            first_name: "tester",
            last_name: "dummy",
            isd_code: "91",
            phone: "9000021123",
            grade: "10",
            school_id: "SCH1001000317",
            admission_id: "INX1PU6EE",
            event_name: "SCORE",
            level: "Prelims",
            round: "Round 1",
            exam_name: "NEET",
            Q1: "4",
            Q2: "3",
            Q3: "2",
            Q4: "1",
            Q5: "3",
            Q6: "3",
            Q7: "4",
            Q8: "3",
            Q9: "2",
            Q10: "1",
            Q11: "3",
            Q12: "3",
            Q13: "2",
            Q14: "1",
            Q15: "3",
            Q16: "3",
            Q17: "4",
            Q18: "3",
            Q19: "2",
            Q20: "1",
          },
        ];
      case "globalStudentsRegister":
        return [
          {
            isd_code: "91",
            first_name: "John",
            last_name: "Doe",
            phone: "1234567890",
            grade: "10",
            school_id: "SCHOOL123",
            admission_id: "INX60273",
          },
        ];
      case "hierarchyUpload":
        return [
          {
            first_name: "John",
            last_name: "Doe",
            emp_id: "HYD10234",
            phone: "1234567890",
            L1_first_name: "LOne",
            L1_last_name: "Doe",
            L1_emp_id: "HYD10235",
            L1_phone: "1224567890",
            L2_first_name: "LTwo",
            L2_last_name: "Doe",
            L2_emp_id: "HYD10236",
            L2_phone: "1244567890",
          },
        ];
      default:
        return [];
    }
  };

  const downloadSampleCSV = () => {
    const data = getSampleData();
    const csv = Papa.unparse(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `sample_${uploadType}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileUpload = (event) => {
    const fileInput = event.target;
    const file = fileInput.files[0];

    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".csv")) {
      showErrorPopup("Please upload a file with .csv extension");
      fileInput.value = "";
      return;
    }
    if (file.name.includes(" ")) {
      showErrorPopup(
        "File name should not contain any spaces. Please rename your file and try again."
      );
      fileInput.value = "";
      return;
    }
    const maxSize = 20 * 1024 * 1024;
    if (file.size > maxSize) {
      showErrorPopup("File size must be less than 20MB");
      fileInput.value = "";
      return;
    }
    setFile(file);
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        handleFileChange(results.data);
      },
      error: (error) => {
        console.error("Error parsing CSV:", error);
        showErrorPopup("Error parsing CSV file. Please check the file format.");
        fileInput.value = "";
      },
    });
  };
  const openFileDialog = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <section className="upload-step" aria-label="Upload CSV">
      <div className="upload-step__card">
        <div
          className="upload-buttons"
          role="group"
          aria-label="Upload actions"
        >
          <label
            className="uploadInput"
            htmlFor="fileInput"
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                openFileDialog();
              }
            }}
            onClick={(event) => {
              event.preventDefault();
              openFileDialog();
            }}
          >
            UPLOAD FILE
          </label>
          <input
            type="file"
            id="fileInput"
            accept=".csv"
            className="upload-step__file-input"
            onChange={handleFileUpload}
            ref={fileInputRef}
          />
          {uploadType && (
            <button
              type="button"
              className="uploadInput"
              onClick={downloadSampleCSV}
            >
              DOWNLOAD SAMPLE
            </button>
          )}
        </div>
        <ul className="upload-step__guidelines">
          <li>File size must be less than 20MB.</li>
          <li>Supported format: .csv</li>
          <li>Download sample CSV for reference.</li>
        </ul>
      </div>
      <Popup
        isVisible={isPopupVisible}
        onClose={() => setIsPopupVisible(false)}
        title="Error"
        isWarning={true}
        showSubtitle={false}
        SecondBtnTitle="Close"
        handelPrimery={() => setIsPopupVisible(false)}
      >
        <p>{popupMessage}</p>
      </Popup>
    </section>
  );
};

export default UploadStep;
